const organizationMarkupSchema = () => {
  const SITE_URL = process.env.NEXT_PUBLIC_SITE_URL;
  return {
    '@type': 'Organization',
    '@id': `${SITE_URL}/#organization`,
    name: 'Quran Pro',
    url: `${SITE_URL}`,
    logo: {
      '@type': 'ImageObject',
      inLanguage: 'en-US',
      url: `${SITE_URL}/logo/light.svg`,
      contentUrl: `${SITE_URL}/logo/light.svg`,
      caption: 'Quran Pro',
    },
  };
};

export default organizationMarkupSchema;
